import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tp-paginator-title',
  templateUrl: './paginator-title.component.html',
  styleUrls: ['./paginator-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorTitleComponent {
  @Input() pageIndex = 0;
  @Input() pageSize = 0;
  @Input() total = 0;

  getItemsEdgeNumber(): number {
    const maxPossibleEdgeNumber = this.pageSize * (this.pageIndex + 1);

    return Math.min(maxPossibleEdgeNumber, this.total);
  }
}
